<template>
  <PanelV2 type="w7" mode="simple">
    <template v-slot:content-solt>
      <img src="@/assets/html5/icon_result_success@2x.png" alt="" />
      <span class="title">Application has been submitted</span>
      <span class="sub-title">This will be submitted for assessment.</span>
      <span class="hotline"
        >For any concerns, please contact our
        <a @click="openDialog">Merchant Services Hotline</a></span
      >
      <!-- <el-button type="primary" @click="goBackAppIndex()">Return to Login</el-button> -->
      <HotLinePop v-if="showDialog" @closeDialog="closeDialog" />
    </template>
  </PanelV2>
</template>

<script>
import HotLinePop from "../components/HotLinePop.vue";
export default {
  name: "FinishProcess",
  components: {
    HotLinePop,
  },
  data() {
    return {
      showDialog: false,
      statusType: {
        '0': {
          icon: '',
          title: 'Your Individual merchant application is still incomplete.',
          btntitle: 'Would you like to resume your application?'
        },
        '1': {
          icon: '',
          title: 'Your application has been approved.',
          btntitle: 'Okay'
        },
        '2': {
          icon: '',
          title: 'Your application has been declined.',
          btntitle: 'Okay'
        },
        '3': {
          icon: '',
          title: 'Your application has been cancelled.',
          btntitle: 'Okay'
        },
        '7': {
          icon: '',
          title: 'Your application is still in progress.',
          btntitle: 'Okay'
        },
      }
    };
  },
  methods: {
    toIndex() {
      this.$router.push({ path: "/check-mid-process" });
    },
    openDialog() {
      this.showDialog = true;
    },
    closeDialog() {
      this.showDialog = false;
    },
  },
};
</script>


<style lang="scss" scoped>
.panel-v2 {
  height: 561px;
  text-align: center;

  img {
    margin: 32px 0 0;
    width: 120px;
  }

  .title {
    margin: 32px 0 0;
    font: normal normal normal 24px/40px Nunito-bold;
    letter-spacing: 0px;
    color: #2e2e2e;
  }

  .sub-title {
    margin: 16px 0 0;
    font: normal normal normal 16px/24px Nunito;
    letter-spacing: 0px;
    color: #2e2e2e;
  }
  .hotline {
    margin-top: 60px;
    margin-bottom: 60px;
  }
  a {
    color: #0072d8;
    text-decoration: underline;
    cursor: pointer;
  }
  .el-button {
    width: 318px;
  }
}
</style>
